import Breakpoints from 'helpers/breakpoints';

/**
 * Social sharing generic script designed to work with any wrapper
 *
 * it needs options to instruct the dom target to trigger social share such as Facebook, Twitter, Link
 */
class SocialShare {
    constructor(element, options) {
        let defaultOptions = {
            facebookEl: '.js-facebook-share',
            twitterEl: '.js-twitter-share',
            linkEl: '.js-link-share'
        };

        this.options = $.extend(defaultOptions, options);
        this._ = element;
        this.tooltips = $(this._).find('.tooltips');

        this.b = new Breakpoints();
        this.isLargeScreen = window.innerWidth > this.b.getMax('tabletPortrait');

        this.__init();
    }

    /**
     * Get offset of an element
     * @param el
     * @returns {{top: number, left: number}}
     */
    static offset(el) {
        var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    /**
     * Debounce function
     * [Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)]
     * @param func
     * @param wait
     * @param immediate
     * @returns {executedFunction}
     */
    static debounce(func, wait, immediate) {
        var timeout;

        return function executedFunction() {
            var context = this;
            var args = arguments;

            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };

            var callNow = immediate && !timeout;

            clearTimeout(timeout);

            timeout = setTimeout(later, wait);

            if (callNow) func.apply(context, args);
        };
    }

    __init() {
        this.__calculateStickyAnchor();

        // calculate social share sticky anchor (compensating subnav height)
        this.__calculateBottomPagePosition();

        this.__eventListeners();
    }
    facebookEventHandler(e) {
        e.preventDefault();
        if (
            e.type === 'click' ||
            (e.type === 'keypress' && (e.code === 'Enter' || e.code === 'Space'))
        ) {
            let width = 700;
            let height = 350;
            let left = screen.width / 2 - width / 2;
            let top = screen.height / 2 - height / 2;
            let url =
                'http://www.facebook.com/dialog/share?app_id=' +
                CBS.Registry.facebook_app_id +
                '&display=popup';
            url += '&href=' + encodeURIComponent($('link[rel="canonical"]').attr('href'));

            window.open(
                url,
                'SOCIAL_SHARE',
                'width=' +
                    width +
                    ',height=' +
                    height +
                    ',status=0,toolbar=0,top=' +
                    top +
                    ',left=' +
                    left
            );
        }
    }
    twitterEventHandler(e) {
        e.preventDefault();
        if (
            e.type === 'click' ||
            (e.type === 'keypress' && (e.code === 'Enter' || e.code === 'Space'))
        ) {
            let width = 500;
            let height = 500;
            let left = screen.width / 2 - width / 2;
            let top = screen.height / 2 - height / 2;
            let link = $('link[rel="canonical"]').attr('href');
            let tx = $('meta[property="og:title"]').attr('content');

            window.open(
                'https://twitter.com/intent/tweet?text=' +
                    encodeURI(tx) +
                    '&url=' +
                    encodeURIComponent(link),
                'SOCIAL_TW',
                'width=' +
                    width +
                    ',height=' +
                    height +
                    ',status=0,toolbar=0,top=' +
                    top +
                    ',left=' +
                    left
            );
        }
    }
    linkCopyEventHandler(e) {
        e.preventDefault();
        if (
            e.type === 'click' ||
            (e.type === 'keypress' && (e.code === 'Enter' || e.code === 'Space'))
        ) {
            let fake = document.createElement('textarea');
            fake.value = $('link[rel="canonical"]').attr('href');
            this._.append(fake);
            let t = this._.querySelector('textarea');
            t.focus();
            t.select();

            try {
                let successful = document.execCommand('copy');
                this.tooltips.find('.tooltips__text').text('Copied');
            } catch (err) {
                console.error(err);
            } finally {
                this._.querySelector('textarea').remove();
            }
        }
    }
    __eventListeners() {
        // click listener for facebook icon

        const fb = document.querySelector(this.options.facebookEl);
        if (fb) {
            fb.addEventListener('click', (e) => {
                this.facebookEventHandler(e);
            });
            fb.addEventListener('keypress', (e) => {
                this.facebookEventHandler(e);
            });
        }
        const tw = document.querySelector(this.options.twitterEl);
        if (tw) {
            tw.addEventListener('click', (e) => {
                this.twitterEventHandler(e);
            });
            tw.addEventListener('keypress', (e) => {
                this.twitterEventHandler(e);
            });
        }
        const link = document.querySelector(this.options.linkEl);
        if (link) {
            link.addEventListener('click', (e) => {
                this.linkCopyEventHandler(e);
            });
            link.addEventListener('keypress', (e) => {
                this.linkCopyEventHandler(e);
            });
        }

        // hover effect listener for all share icons
        $(this._)
            .find('.social__icon')
            .hover(
                (e) => {
                    let offset = $(e.target).offset();
                    let text = $(e.target).attr('rel');

                    if (this.isLargeScreen) {
                        this.tooltips.css('opacity', 1.0).offset({
                            top: offset.top + 5,
                            left: offset.left + 50
                        });
                    } else {
                        this.tooltips.css('opacity', 1.0).offset({
                            top: offset.top - 45,
                            left: offset.left - 8
                        });
                    }
                    this.tooltips.find('.tooltips__text').text(text);
                },
                (e) => {
                    this.tooltips.css('opacity', 0.0);
                }
            );

        // page scroll listener
        window.onscroll = SocialShare.debounce(() => {
            if (this.isLargeScreen) {
                if (window.pageYOffset >= this.stickyAnchor) {
                    if ($('.skybox-loaded').length) {
                        if ($('.skybox-collapsed').length) {
                            $(this._).addClass('sticky');
                        }
                        if ($('.skybox-expanded').length) {
                            $(this._).removeClass('sticky');
                        }
                    } else {
                        $(this._).addClass('sticky');
                    }

                    this.__calculateBottomPagePosition();
                } else {
                    $(this._).removeClass('sticky');
                }

                this.__triggerShowHideContainer();
            } else {
                $(this._).removeClass('sticky');
            }
        }, 15);

        // page resize listener
        window.onresize = SocialShare.debounce(() => {
            this.isLargeScreen = window.innerWidth > this.b.getMax('tabletPortrait');

            if (!this.isLargeScreen) {
                $(this._).show().removeClass('sticky');
            }
        }, 100);
    }

    __triggerShowHideContainer() {
        // if page scroll reach 85% of the page, hide social share container
        if (window.pageYOffset > this.bottomPagePos) {
            $(this._).css('opacity', (this.bottomPagePos + 100 - window.pageYOffset) * 0.01);

            if ($(this._).css('opacity') <= 0) {
                $(this._).hide();
            } else {
                $(this._).show();
            }
        } else {
            // making sure when scroll up, the social share container is visible
            $(this._).css('opacity', 1.0);
            $(this._).show();
        }
    }

    __calculateBottomPagePosition() {
        this.bottomPagePos = $(document).height() - 800; // compensate footer height + visible content area reaching bottom of the page
    }

    __calculateStickyAnchor() {
        // calculate anchor position (if browser is fast, this works)
        this.stickyAnchor = SocialShare.offset(this._).top - 112;

        // but sometime browser can't load banner image fast enough, recalculate anchor
        $('.key__art__banner img.art__image').on('load', () => {
            this.stickyAnchor = SocialShare.offset(this._).top - 112;
        });
    }
}

/**
 * This is the proxy construct the JsCarousel
 */
$.fn.SocialShare = function () {
    let _ = this;
    let opt = arguments[0];

    for (let i = 0; i < _.length; i++) {
        new SocialShare(_[i], opt);
    }
};
